import axiosInstance from "api/setupAxios";

const purchaseOrderApi = {
  listPosClient: async (userId, query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 10, pageNumber = 1 } = paginate;

    if (query.filter?.value?.length > 0) {
      query.filter = JSON.stringify(query.filter);
    } else {
      delete query.filter;
    }
    const data = await axiosInstance.get(`/user/${userId}/po`, {
      params: {
        paginate: JSON.stringify({
          pageSize: pageSize,
          pageNumber,
        }),
        sort: JSON.stringify([["created_at", "asc"]]),
        filter: query.filter,
      },
    });
    return data;
  },

  responseToPo: async (assigneeId, payload = {}) => {
    const data = await axiosInstance.post(
      `/assignee/${assigneeId}/respondPO`,
      payload
    );
    return data;
  },

  requestPayment: async (payload = {}) => {
    const data = await axiosInstance.post(`/assignee/requestPayment`, payload);
    return data;
  },

  downloadPo: async (poId) => {
    const { data } = await axiosInstance.get(`/user/po/${poId}/url`);
    return data;
  },

  downloadUserInvoice: async (poId) => {
    const { data } = await axiosInstance.get(`/user/invoice/${poId}/url`);
    return data;
  },

  clientPoAllReport: async (userId, payload = {}) => {
    const data = await axiosInstance.post(`/user/${userId}/po/report`, payload);
    return data;
  },
};

export default purchaseOrderApi;
